import StreamsManagement from './StreamsManagement';

export default StreamsManagement;
